<div class="version-wrapper position-relative">

  <!-- ── Botón info ─────────────────────────────────────────── -->
  <button class="btn btn-version" (click)="toggleDropdown($event)" aria-label="Versión desplegada">
    <i class="bi bi-info-circle fs-5"></i>
  </button>

  <!-- ── Dropdown ───────────────────────────────────────────── -->
  @if (isOpen) {
    <div class="version-dropdown" (click)="$event.stopPropagation()">

      <div class="version-header">
        <span class="fw-semibold small">Versión desplegada</span>
      </div>

      <div class="version-body">

        <div class="version-block">
          <div class="block-title">Frontend</div>
          @if (frontendInfo) {
            <div class="block-row">v{{ frontendInfo.version }} · {{ frontendInfo.env }}</div>
            <div class="block-row text-muted" [title]="frontendInfo.commitSha || ''">
              {{ frontendInfo.commitShaShort || 'sin commit' }} ({{ frontendInfo.branch || '?' }})
            </div>
            <div class="block-row text-muted">{{ formatDate(frontendInfo.buildDate) }}</div>
          } @else {
            <div class="block-row text-muted">no disponible</div>
          }
        </div>

        <div class="version-block">
          <div class="block-title">Backend</div>
          @if (backendInfo) {
            <div class="block-row">v{{ backendInfo.version }} · {{ backendInfo.env }}</div>
            <div class="block-row text-muted" [title]="backendInfo.commitSha || ''">
              {{ backendInfo.commitShaShort || 'sin commit' }} ({{ backendInfo.branch || '?' }})
            </div>
            <div class="block-row text-muted">{{ formatDate(backendInfo.buildDate) }}</div>
          } @else {
            <div class="block-row text-muted">no disponible</div>
          }
        </div>

      </div>

    </div>
  }

</div>
